import { ListSortDirection, Sort } from "../../models/api/sort";
import { EmployeeDependenTypeDTO, EmployeeDependenTypeSTO } from "../../models/employee-dependent-type";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeDependentTypesApiService extends BaseApiService<EmployeeDependenTypeDTO, EmployeeDependenTypeSTO> {
  constructor() {
    super({
      servicePath: "/EmployeeDependentTypes",
      loadItemsPath: "/GetEmployeeDependentTypes",
      saveItemsPath: "/SaveEmployeeDependentTypes",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
